/**
 * 无需跳转登录的页面的name
 */
export const NO_NEED_LOGIN_NAMES = ['Home', 'Login', 'Register', 'markets']

/**
 * DEX的页面
 */
export const DEX_ROUTES = ['markets', 'trade', 'wallet', 'market', 'search', 'assets', 'orderHistory', 'orderDetails', 'withdrawal', 'withdrawalHistory', 'withdrawalDetail', 'chains', 'deposit', 'orderConfirm', 'userCenter', 'Unsubscribe']
